import { CADVisual3D } from '../types';

export function computeCenter(positionData: Float32Array): [number, number, number] {
  let max_x = Number.MIN_VALUE;
  let max_y = Number.MIN_VALUE;
  let max_z = Number.MIN_VALUE;

  let min_x = Number.MAX_VALUE;
  let min_y = Number.MAX_VALUE;
  let min_z = Number.MAX_VALUE;

  for (let i = 0; i < positionData.length; i += 3) {
    const x = positionData[i];
    const y = positionData[i + 1];
    const z = positionData[i + 2];

    max_x = Math.max(max_x, x);
    max_y = Math.max(max_y, y);
    max_z = Math.max(max_z, z);

    min_x = Math.min(min_x, x);
    min_y = Math.min(min_y, y);
    min_z = Math.min(min_z, z);
  }

  return [(max_x + min_x) / 2, (max_y + min_y) / 2, (max_z + min_z) / 2];
}

export function computeCenterOfCenters(centers: [number, number, number][]): [number, number, number] {
  return [
    (Math.max(...centers.map((center) => center[0])) + Math.min(...centers.map((center) => center[0]))) / 2,
    (Math.max(...centers.map((center) => center[1])) + Math.min(...centers.map((center) => center[1]))) / 2,
    (Math.max(...centers.map((center) => center[2])) + Math.min(...centers.map((center) => center[2]))) / 2,
  ];
}
